import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import {
  CountryItem,
  ItalyCityItem,
  ItalyProvinceItem,
  ItalyRegionItem,
  ServiceItem,
} from 'src/app/api/models';
import { CountryService, GeoService, ServicesService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-service-pricing',
  templateUrl: './modal-service-pricing.component.html',
  styleUrls: ['./modal-service-pricing.component.scss'],
})
export class ModalServicePricingComponent {
  question_title: string;
  chosenServices: any[] = [];
  isLocated?: boolean;

  frm_pricing = new FormGroup({
    service_and_pricing_id: new FormControl(undefined, { nonNullable: false }),
    pricing_type_id: new FormControl<number | undefined>(undefined, [Validators.required]),
    // description: new FormControl<string | undefined>(undefined, [Validators.required]),
    //consumo
    usage_unit_id: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    usage_price_multiplier_id: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
    usage_price: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    usage_overcharge_festivity: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
    usage_overcharge_night: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
    usage_overcharge_priority: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
    usage_overcharge_transfer: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
    //pacchetto
    balance_unit_id: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    balance_amount: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    balance_frequency_id: new FormControl({ value: undefined, disabled: true }, [
      Validators.required,
    ]),
  });

  frm_geo = new FormGroup({
    country_iso: new FormControl('', [Validators.required]),
    region: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    province: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
    city: new FormControl({ value: undefined, disabled: true }, [Validators.required]),
  });

  frequency = [{}];
  mode = [{}];
  periodicity = [{}];

  country: CountryItem[] = [];
  region: ItalyRegionItem[] = [];
  province: ItalyProvinceItem[] = [];
  city: ItalyCityItem[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private countryService: CountryService,
    private geoService: GeoService
  ) {
    this.question_title = config.data!.question_title;
    this.chosenServices = config.data!.chosenServices;

    this.isLocated = config.data!.isLocated;
  }

  ngOnInit() {
    this.frequency = [
      { name: 'A intervento', value: 1 },
      { name: 'A giornata', value: 2 },
      { name: 'A ore', value: 3 },
    ];
    this.mode = [
      { name: 'A intervento', value: 1 },
      { name: 'A persona', value: 2 },
    ];
    this.periodicity = [
      { name: 'Settimana', value: 1 },
      { name: 'Mese', value: 2 },
      { name: 'Anno', value: 3 },
    ];

    this.getCountries();

    this.frm_pricing.get('pricing_type_id')?.valueChanges.subscribe(r => {
      const frm = this.frm_pricing;
      if (r == 1) {
        //CONSUMO: abilito i controls del pricing_type consumo e svuoto eventuali controlli del pacchetto
        this.frm_pricing.get('usage_unit_id')?.enable();
        this.frm_pricing.get('usage_price_multiplier_id')?.enable();
        this.frm_pricing.get('usage_price')?.enable();
        this.frm_pricing.get('usage_overcharge_festivity')?.enable();
        this.frm_pricing.get('usage_overcharge_night')?.enable();
        this.frm_pricing.get('usage_overcharge_priority')?.enable();
        this.frm_pricing.get('usage_overcharge_transfer')?.enable();

        this.frm_pricing.get('balance_unit_id')?.disable();
        // this.frm_pricing.get('balance_unit_id')?.setValue(undefined);
        this.frm_pricing.get('balance_amount')?.disable();
        // this.frm_pricing.get('balance_amount')?.setValue(undefined);
        this.frm_pricing.get('balance_frequency_id')?.disable();
        // this.frm_pricing.get('balance_frequency_id')?.setValue(undefined);
      } else if (r == 2) {
        //PACCHETTO: abilito i controls del pricing_type consumo e svuoto eventuali controlli del consumo
        this.frm_pricing.get('balance_unit_id')?.enable();
        this.frm_pricing.get('balance_amount')?.enable();
        this.frm_pricing.get('balance_frequency_id')?.enable();

        this.frm_pricing.get('usage_unit_id')?.disable();
        // this.frm_pricing.get('usage_unit_id')?.setValue(undefined);
        this.frm_pricing.get('usage_price_multiplier_id')?.disable();
        // this.frm_pricing.get('usage_price_multiplier_id')?.setValue(undefined);
        this.frm_pricing.get('usage_price')?.disable();
        // this.frm_pricing.get('usage_price')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_festivity')?.disable();
        // this.frm_pricing.get('usage_overcharge_festivity')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_priority')?.disable();
        // this.frm_pricing.get('usage_overcharge_priority')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_night')?.disable();
        // this.frm_pricing.get('usage_overcharge_night')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_transfer')?.disable();
        // this.frm_pricing.get('usage_overcharge_transfer')?.setValue(undefined);
      } else if (r == 3) {
        //GRATIS: svuoto e disabilito tutti i controls
        this.frm_pricing.get('usage_unit_id')?.disable();
        // this.frm_pricing.get('usage_unit_id')?.setValue(undefined);
        this.frm_pricing.get('usage_price_multiplier_id')?.disable();
        // this.frm_pricing.get('usage_price_multiplier_id')?.setValue(undefined);
        this.frm_pricing.get('usage_price')?.disable();
        // this.frm_pricing.get('usage_price')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_festivity')?.disable();
        // this.frm_pricing.get('usage_overcharge_festivity')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_priority')?.disable();
        // this.frm_pricing.get('usage_overcharge_priority')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_night')?.disable();
        // this.frm_pricing.get('usage_overcharge_night')?.setValue(undefined);
        this.frm_pricing.get('usage_overcharge_transfer')?.disable();
        // this.frm_pricing.get('usage_overcharge_transfer')?.setValue(undefined);

        this.frm_pricing.get('balance_unit_id')?.disable();
        // this.frm_pricing.get('balance_unit_id')?.setValue(undefined);
        this.frm_pricing.get('balance_amount')?.disable();
        // this.frm_pricing.get('balance_amount')?.setValue(undefined);
        this.frm_pricing.get('balance_frequency_id')?.disable();
        // this.frm_pricing.get('balance_frequency_id')?.setValue(undefined);

        this.frm_pricing.valid;
      }
    });
    if (this.config.data!.initialValue) {
      this.frm_pricing.patchValue(this.config.data!.initialValue);
    } else {
      this.frm_pricing.reset();
    }

    this.frm_geo.get('country_iso')?.valueChanges.subscribe(r => {
      if (r === 'IT') {
        this.frm_geo.get('region')?.enable();
        this.geoService.geoControllerGetRegions().subscribe({
          next: res => {
            this.region = res.data.list;
          },
        });
      } else {
        this.frm_geo.get('region')?.disable();
      }
    });
    this.frm_geo.get('region')?.valueChanges.subscribe({
      next: (res: any) => {
        if (res) {
          this.frm_geo.get('province')?.enable();
          this.geoService.geoControllerGetProvincesByRegion({ id: res.id }).subscribe({
            next: prov => {
              this.province = prov.data.list;
            },
          });
        }
      },
    });
    this.frm_geo.get('province')?.valueChanges.subscribe({
      next: (res: any) => {
        if (res) {
          this.frm_geo.get('city')?.enable();
          this.geoService.geoControllerGetProvince({ id: res.id }).subscribe({
            next: c => {
              this.city = c.data.cities;
            },
          });
        }
      },
    });
  }

  getCountries() {
    this.countryService.countryControllerGetAll().subscribe(response => {
      this.country = response.data.list;
      this.frm_geo
        .get('country_iso')!
        .setValue(response.data.list.find(p => p.name == 'Italia')!.ISO);
    });
  }

  submit() {}

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ pricing: this.frm_pricing.value, localization: this.frm_geo });
  }
}
